import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';
import { renderErrorBoundaryFallback } from '../../../../utils/error-boundary/error-boundary';

export interface LazyComponentProps {
    handleSignout: () => void;
}
interface IComponentLazyWrapper {
    fallback: NonNullable<React.ReactNode>;
    lazyComponent: React.LazyExoticComponent<(props: object | LazyComponentProps) => JSX.Element>;
    handleSignout: () => void;
}

export const ComponentLazyWrapper: React.FC<IComponentLazyWrapper> = ({
    fallback,
    lazyComponent: LazyComponent,
    handleSignout,
}): React.ReactElement => {
    return (
        <>
            <Suspense fallback={fallback}>
                <ErrorBoundary fallback={renderErrorBoundaryFallback}>
                    <LazyComponent handleSignout={handleSignout} />
                </ErrorBoundary>
            </Suspense>
        </>
    );
};

export default ComponentLazyWrapper;
